import { c as _c } from "react/compiler-runtime";
import { isVaultDataDecrypted, isVaultDataEmpty } from '@onefootprint/core';
import type { DataIdentifier } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import type { VaultType } from '@/entities/hooks/use-entity-vault';
export type UseFieldProps = {
  label: string;
  value: unknown;
  transforms: unknown;
  isDecrypted: boolean;
  isEmpty: boolean;
};
const useField = vaultData => {
  const $ = _c(10);
  const {
    t
  } = useTranslation("common");
  let t0;
  if ($[0] !== t || $[1] !== vaultData?.vault) {
    t0 = di => {
      const hasLegalStatus = !!vaultData?.vault["id.us_legal_status"];
      if (di === "id.nationality" && hasLegalStatus) {
        return t(_temp);
      }
      return t($_0 => $_0.di[di]);
    };
    $[0] = t;
    $[1] = vaultData?.vault;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const getLabel = t0;
  let t1;
  if ($[3] !== t || $[4] !== vaultData?.vault) {
    t1 = di_0 => {
      const value = vaultData?.vault[di_0 as keyof typeof vaultData.vault];
      if (di_0 === "id.us_legal_status") {
        if (value === "citizen") {
          return t(_temp2);
        }
        if (value === "permanent_resident") {
          return t(_temp3);
        }
        if (value === "visa") {
          return t(_temp4);
        }
      }
      return value;
    };
    $[3] = t;
    $[4] = vaultData?.vault;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const getValue = t1;
  let t2;
  if ($[6] !== getLabel || $[7] !== getValue || $[8] !== vaultData?.transforms) {
    t2 = di_1 => {
      const value_0 = getValue(di_1);
      return {
        label: getLabel(di_1),
        value: value_0,
        transforms: vaultData?.transforms[di_1 as keyof typeof vaultData.transforms],
        isDecrypted: isVaultDataDecrypted(value_0),
        isEmpty: isVaultDataEmpty(value_0)
      };
    };
    $[6] = getLabel;
    $[7] = getValue;
    $[8] = vaultData?.transforms;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const getProps = t2;
  return getProps;
};
export default useField;
function _temp($) {
  return $.di.id.country_of_birth;
}
function _temp2($_1) {
  return $_1.pages.user.vault.usLegalStatus.status.options.citizen;
}
function _temp3($_2) {
  return $_2.pages.user.vault.usLegalStatus.status.options.permanent_resident;
}
function _temp4($_3) {
  return $_3.pages.user.vault.usLegalStatus.status.options.visa;
}